import { useEffect, useState } from "react";

const BASE = "https://www.emsifa.com/api-wilayah-indonesia/api";
const cache = {};

export async function load(url) {
  if (!cache[url]) cache[url] = fetch(`${BASE}/${url}`).then((r) => r.json());
  return cache[url];
}

const norm = (s) => (s || "").toUpperCase().replace(/^(KABUPATEN|KAB\.?|KOTA ADM\.?|KOTA)\s+/, "").replace(/[^A-Z0-9]/g, "");

function findIn(list, name) {
  const n = norm(name);
  if (!n) return null;
  return list.find((o) => norm(o.name) === n) || list.find((o) => norm(o.name).includes(n) || n.includes(norm(o.name)));
}

export async function addressFromKtp(d) {
  const out = { street: [d.alamat, d.rt_rw && `RT/RW ${d.rt_rw}`].filter(Boolean).join(", ") };
  const steps = [["province", "provinsi", () => "provinces.json"], ["regency", "kabupaten_kota", (o) => `regencies/${o.province_id}.json`],
    ["district", "kecamatan", (o) => `districts/${o.regency_id}.json`], ["village", "kel_desa", (o) => `villages/${o.district_id}.json`]];
  for (const [k, src, url] of steps) {
    const hit = findIn(await load(url(out)), d[src]);
    if (!hit) break;
    out[`${k}_id`] = hit.id;
    out[k] = hit.name;
  }
  return out;
}

const LEVELS = [
  ["province", "Provinsi", () => "provinces.json"],
  ["regency", "Kabupaten/Kota", (v) => v.province_id && `regencies/${v.province_id}.json`],
  ["district", "Kecamatan", (v) => v.regency_id && `districts/${v.regency_id}.json`],
  ["village", "Kelurahan/Desa", (v) => v.district_id && `villages/${v.district_id}.json`],
];

function LevelSelect({ level, label, url, value, onPick }) {
  const [opts, setOpts] = useState([]);
  useEffect(() => {
    setOpts([]);
    if (url) load(url).then(setOpts).catch(() => setOpts([]));
  }, [url]);
  return (
    <label className="block">
      <span className="text-xs font-semibold text-slate-600">{label}</span>
      <select data-testid={`region-${level}-select`} className="field mt-1" disabled={!url} value={value || ""}
        onChange={(e) => onPick(e.target.value, opts.find((o) => o.id === e.target.value)?.name || "")}>
        <option value="">Pilih {label}</option>
        {opts.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
      </select>
    </label>
  );
}

export default function RegionSelect({ value = {}, onChange }) {
  const pick = (idx) => (id, name) => {
    const next = { ...value, [`${LEVELS[idx][0]}_id`]: id, [LEVELS[idx][0]]: name };
    LEVELS.slice(idx + 1).forEach(([k]) => { next[`${k}_id`] = ""; next[k] = ""; });
    onChange(next);
  };
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        {LEVELS.map(([k, label, url], i) => (
          <LevelSelect key={k} level={k} label={label} url={url(value)} value={value[`${k}_id`]} onPick={pick(i)} />
        ))}
      </div>
      <label className="block">
        <span className="text-xs font-semibold text-slate-600">Nama Jalan / Detail</span>
        <input data-testid="region-street-input" className="field mt-1" placeholder="Jl. Melati No. 12, RT 03/RW 05"
          value={value.street || ""} onChange={(e) => onChange({ ...value, street: e.target.value })} />
      </label>
    </div>
  );
}
